export const PANEL = "admin";

export const MEDIATYPE_THUMBNAIL = 'THUMBNAIL';
export const MEDIATYPE_BANNER = 'BANNER';
export const THUMBNAIL_WIDTH = 300;
export const THUMBNAIL_HEIGHT = 300;
export const BANNER_WIDTH = 800;
export const BANNER_HEIGHT = 400;
export const CLINIC_IMAGE_WIDTH = 120;
export const CLINIC_IMAGE_HEIGHT = 120;

export const APP_VERSION_MISMATCH = 'APP version mismatch';

export const MODULE_API_LIST = [
  {
    "forum": [
      {
        "channel": [
          "/community/channel/get",
          "/community/channel/declineApproveJoinRequest",
          "/community/channel/leave"
        ]
      }
    ],
    "education": [
      {
        "library": [
          "/library/get"
        ],
        "clinic": [
          "/clinic/get"
        ],
        "event": [
          "/event/get"
        ],
        "newsFeed": [
          "/newsFeed/get"
        ],
        "lpProfile": [
          "/lpProfile/get"
        ],
        "faq": [
          "/faq/get"
        ]
      }
    ],
    "product": [
      {
        "product": [
          "/productParameter/get",
          "/product/get"
        ]
      }
    ],
    "media": [
      {
        "newsFeed": [
          "/newsCategory/list",
          "/newsFeed/get",
          "/newsFeed/comment/get"
        ]
      }
    ]
  }
];